import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { TeklifEditComponent } from './teklif-edit.component';
import { TeklifKartComponent } from './teklif-kart.component';
import { TeklifKartSadeComponent } from './teklif-kart-sade.component';

@DinamikBilesen({
  id: 'teklif',
  baslik: 'Teklif',
  aciklama: 'Teklif hazırla',
  ikon: 'file-text',
  kategori: 'satis',
})
class Teklif {
  paylas_kutusu = TeklifEditComponent;
  paylasilmis_kart = TeklifKartComponent;
  paylasilmis_kart_sade = TeklifKartSadeComponent;
}
